import React, { Component } from "react";
import { List } from "../transactions/nfoAndNewPurchase";
import Signbutton, { Debtbutton } from "../../forms/button";
import Paper from "@material-ui/core/Paper";
import { connect } from "react-redux";
import { Input } from "../../forms/input";

import { getcaptialgainStatment } from "../../../store/actions/mailback";

import "react-datepicker/dist/react-datepicker.css";

import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";

const CGF = (props) => {
  return (
    <>
      <Paper
        className="digital-form-container"
        style={{
          boxShadow: "0px 0px 2px 0px lightgray",
          marginTop: 20,
          margin: "20px 30px 20px",
        }}
      >
        <div className="digital-form-left-div">
          <List investorData={props.investorData} />
        </div>
        <div className="digital-form-Right-div">
          <div className="transaction-details">
            <div className="title">Capital Gains Account Statement</div>
          </div>
          <div className="input-margin">
            <Input name="PAN Number" value={props.investorData.PAN} disabled />
          </div>
          <div className="input-margin">
            <Input name="Email ID" />
          </div>
          <div className="input-margin">
            <Input name="Period" />
          </div>
          <div className="input-margin">
            <Input name="Delivery Option" value="Email a download link" />
          </div>
          <div className="input-margin">
            <div className="input-name">Statement Format</div>
            <FormControl component="fieldset">
              <RadioGroup
                aria-label="Search"
                name="search"
                style={{ flexDirection: "row" }}
              >
                <div className="investor-radio-button">
                  <FormControlLabel
                    value="PDF"
                    control={
                      <Radio
                        className="investor-search-radio"
                        style={{ color: "#007ac8" }}
                      />
                    }
                    className="investor-formcontrol-label"
                    style={{ margin: 0 }}
                  />
                  <div className="investor-form-label">PDF</div>
                </div>
                <div className="investor-radio-button">
                  <FormControlLabel
                    value="EXCEL"
                    control={
                      <Radio
                        className="investor-search-radio"
                        style={{ color: "#007ac8" }}
                      />
                    }
                    className="investor-formcontrol-label"
                    style={{ margin: 0 }}
                  />
                  <div className="investor-form-label">EXCEL</div>
                </div>
              </RadioGroup>
            </FormControl>
          </div>
          <div className="input-margin">
            <Input name="Password" type="password" />
          </div>
          <div className="input-margin">
            <Input name="Confirm Password" type="password" />
          </div>
        </div>
      </Paper>
    </>
  );
};

export default connect(
  ({ authReducer }) => {
    const { investorData, userId, token } = authReducer;
    return { investorData, userId, token };
  },
  { getcaptialgainStatment }
)(CGF);
